import React from "react";
import { useTranslation } from "react-i18next";
import TransactionItem from "../core/operatorDashboard/TransactionItem";
import EmptyTransaction from "../core/operatorDashboard/EmptyTransaction";
import { ImSpinner } from "react-icons/im";
import { RecentTransactionType } from "../../@types";
import { EmptyPieChart } from "./PieChart/Empty";
import InvoiceEmptyStats from "../../assets/icons/InvoiceEmptyStats";
import RecentTransactionLoaders from "./Loading/RecentTransactionLoaders";

interface RecentTransactionsProps {
  transactions: RecentTransactionType[];
  isLoading: boolean;
  isFilter: boolean;
}

const RecentTransactions = ({
  transactions,
  isLoading,
  isFilter,
}: RecentTransactionsProps) => {
  const { t } = useTranslation("dashboard");

  const emptyFilterComponent = () => {
    return (
      <div className=" pt-0 bg-white rounded-lg w-[368px] h-[690px] pb-10"></div>
    );
  };
  const emptyTransactions = () => {
    return (
      <div className=" pt-0 bg-white rounded-lg w-full pb-10">
        <EmptyPieChart
          link={`/invoices/create`}
          buttonText="Create an invoice"
          icon={<InvoiceEmptyStats />}
          paragraph={
            <>
              Create your invoice to start <br /> recording payments.
            </>
          }
          title="Recent Transaction"
        />
      </div>
    );
  };
  return (
    <>
      {isLoading ? (
        <RecentTransactionLoaders />
      ) : (
        <>
          {transactions.length == 0 ? (
            isFilter ? (
              emptyFilterComponent()
            ) : (
              emptyTransactions()
            )
          ) : (
            <div className="rounded-lg bg-white py-3 lg:py-6 w-full">
              <div className="flex justify-between items-center px-3 md:px-6">
                <h2 className="text-[#1D2939] font-medium leading-6 lg:text-[16px] text-[14px] ">
                  {t("recentTransactions")}
                </h2>
                <div className="flex items-center space-x-5">
                  <div className="flex lg:space-x-2 space-x-1 items-center">
                    <span className="md:h-4 h-2 md:w-4 w-2 bg-[#32D583] rounded"></span>{" "}
                    <span className="lg:text-[16px] text-[12px]">Invoices</span>
                  </div>
                  <div className="flex lg:space-x-2 space-x-1 items-center">
                    <span className="md:h-4 h-2 md:w-4 w-2 bg-[#F04438] rounded"></span>{" "}
                    <span className="lg:text-[16px] text-[12px]">Expenses</span>
                  </div>
                </div>
              </div>
              <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />

              <div className="mt-3 px-3 md:px-6">
                {transactions.length > 0 ? (
                  <div className="space-y-2">
                    {transactions.map(({ data }: any, index: number) => (
                      <TransactionItem key={data.id} data={data} />
                    ))}
                  </div>
                ) : (
                  <EmptyTransaction text="Create your invoice to start recording payments" />
                )}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default RecentTransactions;
